var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.params.formName === 'modifyDatasetForm' || _vm.$route.params.form_name === 'modifyDatasetForm')?_c('ModifyDatasetForm'):_c('NewDatasetForm')
}
var staticRenderFns = []

export { render, staticRenderFns }